export default function () {
  return {
    messages: [],
    isLoadingMessages: false,

    genericDocuments: [],
    isLoadingGenericDocuments: false,

    unreadDocuments: undefined,
    unreadDocumentsLast6Months: undefined,
    hasUnreadDocumentsLast6Months: false,
  };
}
